// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Çeviriler
const resources = {
  en: {
    translation: {
      home: "Home",
      about: "ABOUT",
      services: "SERVICES",
      products: "PRODUCTS",
      contact: "CONTACT",
      info: "INFORMATION ABOUT OUR PRODUCTS WILL BE AT YOUR SERVICE SOON.",
      
      about_title: {
        tit: "About Us",
        subtit: "We do our job with passion!",
        desc: "In business life, the establishment, management, monitoring and problem detection of the infrastructure of corporate internet applications are the areas we are best at. In our software development infrastructure, we have knowledge and work experience in infrastructure and programming languages ​​such as .Net Core, MVC, C#, Python and Microsoft SQL. Courses have been taken from universities in the field of Machine Learning and Artificial Intelligence and our communication with our faculty members and instructors on these subjects continues. Our project manager has a project management (PMP) certificate."
    },

      home_title: {
        tit: "Our Artificial Intelligence Solutions Are With You!",
        subtit: "Our Innovative Solutions are for our valued customers!",
        desc: "As Mastersoft, our organization's main field of activity is to develop software and hardware projects using machine learning, deep learning and artificial intelligence algorithms. Our main product will be the software that detects abnormal situations related to cyber security and performance in the servers and applications of institutions providing services over the internet."
    },

    services_title: {
      tit: "Services",
      subtit: "The tools we provide you by service...",  
    },    

    products_title: {
      tit: "Our Products",
      subtit: "What can you do with LogAI?",
      subdesc:"Log analysis, one of the most critical needs of businesses in the digital world, becomes smart, fast and user-friendly with LOG AI. Having both web and mobile interfaces, LOG AI allows you to collect, analyze and visualize all your log data under one roof.",
      desc:"<strong>Listing and Filtering Logs:</strong> LOG AI easily organizes your complex log data. With filtering options that suit your needs, you can quickly access the information you are looking for." 
    },

    contact_title: {
      tit: "Contact Form"
    },

    form: {
      name: "Name",
      surname: "Surname",
      email: "E-mail",
      message: "Message",
      send: "Send"
    },

    footer: {
      copyright: "© 2025 Mastersoft",
      about: "About Us",
      terms: "Terms of Use and Privacy",
      contact: "Contact",
      addressLabel: "Address",
      address: "Üniversiteler Mahallesi 1596.Cadde 6.Arge E Blok No:16 Çankaya/Ankara",
      emailLabel: "E-mail",
      email: "info@mastersoft.com.tr",
      phoneLabel: "Phone",
      phone: "+90 (536) 410-5441",
      followUs: "Follow us!"
    },

    serv: [
      {
        stype: "Front-End Structures",
        sdescription: "We have experience in front-end design with programming languages such as React JS, JavaScript, Angular, and Vue.js.",
      },
      {
        stype: "Back-End Structures",
        sdescription: "Our software development infrastructure includes experience in programming languages such as .Net Core, MVC, C#, Python, and Microsoft SQL.",
      },
      {
        stype: "Machine Learning",
        sdescription: "We develop software that detects anomalies in log records using machine learning and deep learning algorithms.",
      }
    ],

    pros: [
      {
        stype: "Listing and Filtering Logs: ",
        sdescription:  "LOG AI easily organizes your complex log data. You can quickly access the information you are looking for with filtering options that suit your needs."
      },
      {
        stype: "Graphical Visualization: ",
        sdescription: "Analyze your data more clearly and effectively by turning it into graphs. Time series, error rates, and other critical metrics are presented in user-friendly visualizations."
      },
      {
        stype: "Creating Error Scenarios: ",
        sdescription: "Design custom error scenarios to improve your application’s performance and predict problems. LOG AI analyzes these scenarios with its algorithms and provides solutions."
      },
      {
        stype: "Algorithm Performance Evaluation: ",
        sdescription: "Evaluate the accuracy and reliability of the selected analysis algorithms. LOG AI offers an evaluation module optimized for best results."
      },
      {
        stype:"Development with User Feedback: ",
        sdescription:"LOG AI attaches importance to user experience and supports the collection of feedback and improvement of designs accordingly."
      }
    ]

    },
  },
  tr: {
    translation: {
      home: "Anasayfa",
      about: "HAKKIMIZDA",
      services: "HİZMETLER",
      products: "ÜRÜNLER",
      contact: "İLETİŞİM",
      info: "ÜRÜNLERİMİZ İLE İLGİLİ BİLGİLER YAKIN ZAMANDA HİZMETİNİZDE OLACAKTIR.",
      about_title: {
        tit: "Hakkımızda",
        subtit: "İşimizi tutkuyla yapıyoruz!",
        desc: "İş hayatında kurumsal internet uygulamalarının altyapısının kurulumu, yönetimi, izlenmesi ve problemlerin tespiti en iyi olduğumuz alanlardır. Yazılım geliştirme altyapımızda .Net Core, MVC, C#, Python ve Microsoft SQL gibi altyapı ve programlama dillerinde bilgi ve iş deneyimine sahibiyiz. Makine Öğrenmesi ve Yapay Zeka alanında üniversitelerden dersler alınmış ve bu konularda öğretim üyeleri hocalarımız ile iletişimlerimiz devam etmektedir. Proje sorumlumuzun, proje yönetimi (PMP) sertifikası bulunmaktadır."
      },

      home_title: {
        tit: "Yapay Zeka Çözümlerimiz Sizlerle!",
        subtit: "Yenilikçi Çözümlerimiz siz değerli müşterilerimiz için!",
        desc: "Mastersoft olarak kuruluşumuzun ana faaliyet alanı makine öğrenmesi, derin öğrenme ve yapay zeka algoritmalarının kullanıldığı yazılım ve donanım projeleri geliştirmektir. Başlıca ürünümüz, internet üzerinden hizmet veren kurumların sunucu ve uygulamalarına yapılan siber güvenlik ve performans ile ilgili anormal durumları tespit eden yazılım olacaktır."
    },

      services_title: {
        tit: "Hizmetler",
        subtit: "Sizlere hizmet sağladığımız araçlar...",
    },

      products_title: {
        tit: "Ürünlerimiz",
        subtit: "LogAI ile neler yapabilirsiniz?",
        subdesc:"Dijital dünyada işletmelerin en kritik ihtiyaçlarından biri olan log analizi, LOG AI ile akıllı, hızlı ve kullanıcı dostu bir hale geliyor. Hem web hem de mobil arayüzlere sahip olan LOG AI, tüm log verilerinizi tek bir çatı altında toplamanıza, analiz etmenize ve görselleştirmenize olanak tanır.",
        desc:"<strong>Logların Listelenmesi ve Filtrelenmesi:</strong> LOG AI, karmaşık log verilerinizi kolayca organize eder. İhtiyacınıza uygun filtreleme seçenekleriyle, aradığınız bilgilere hızlıca ulaşabilirsiniz.",
    },

      contact_title: {
        tit: "İletişim Formu"
      },

      form: {
        name: "Ad",
        surname: "Soyad",
        email: "E-posta",
        message: "Mesaj",
        send: "Gönder"
      },

      footer: {
        copyright: "© 2025 Mastersoft",
        about: "Hakkımızda",
        terms: "Kullanım Koşulları ve Gizlilik",
        contact: "İletişim",
        addressLabel: "Adres",
        address: "Üniversiteler Mahallesi 1596.Cadde 6.Arge E Blok No:16 Çankaya/Ankara",
        emailLabel: "E-posta",
        email: "info@mastersoft.com.tr",
        phoneLabel: "Telefon",
        phone: "+90 (536) 410-5441",
        followUs: "Bizi takip edin!"
      },

    serv: [
      {
        stype: "Front End Yapılar",
        sdescription: "Ön yüz tasarımında React JS, JavaScript, Angular ve Vue.js gibi programlama dillerinde deneyim sahibiyiz.",
      },
      {
        stype: "Back End Yapılar",
        sdescription: "Yazılım geliştirme altyapımızda .Net Core, MVC, C#, Python ve Microsoft SQL gibi programlama dillerinde deneyime sahibiz.",
      },
      {
        stype: "Makine Öğrenmesi",
        sdescription: "Log kayıtlarındaki anormal durumları makine öğrenmesi ve derin öğrenme algoritmaları ile tespit eden yazılım geliştirmekteyiz.",
      }
    ],

    pros: [
      {
        stype: "Logların Listelenmesi ve Filtrelenmesi: ",
        sdescription:  " LOG AI, karmaşık log verilerinizi kolayca organize eder. İhtiyacınıza uygun filtreleme seçenekleriyle, aradığınız bilgilere hızlıca ulaşabilirsiniz."
      },
      {
        stype: "Grafiksel Görselleştirme: ",
        sdescription: "Verilerinizi grafiklere dönüştürerek daha anlaşılır ve etkili bir şekilde analiz edin. Zaman serileri, hata oranları ve diğer kritik metrikler, kullanıcı dostu görselleştirmelerle sunulur."
      },
      {
        stype: "Hata Senaryoları Oluşturma: ",
        sdescription: "Uygulamanızın performansını artırmak ve sorunları öngörmek için özel hata senaryoları tasarlayın. LOG AI, algoritmalarıyla bu senaryoları analiz ederek çözümler sunar."
      },
      {
        stype: "Algoritma Performansı Değerlendirme: ",
        sdescription: "Seçilen analiz algoritmalarının doğruluk oranını ve güvenilirliğini değerlendirin. LOG AI, en iyi sonuçlar için optimize edilmiş bir değerlendirme modülü sunar."
      },
      {
        stype:"Kullanıcı Geri Bildirimleri ile Geliştirme: ",
        sdescription:"Kullanıcı deneyimine önem veren LOG AI, geri bildirimlerin toplanmasını ve tasarımların bu doğrultuda iyileştirilmesini destekler."
      }
    ]

    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "tr",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
